/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Statscountin30days3Inputs */

const en_statscountin30days3 = /** @type {(inputs: Statscountin30days3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} in 30 days`)
};

const de_statscountin30days3 = /** @type {(inputs: Statscountin30days3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} in 30 Tagen`)
};

/**
* | output |
* | --- |
* | "{count} in 30 days" |
*
* @param {Statscountin30days3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const statscountin30days3 = /** @type {((inputs: Statscountin30days3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Statscountin30days3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_statscountin30days3(inputs)
	return de_statscountin30days3(inputs)
});
export { statscountin30days3 as "statsCountIn30Days" }